import type MarkdownIt from 'markdown-it'
import { type ComponentProps, type ElementType, useMemo } from 'react'
import { mdFull } from 'src/utils/markdown'

/**
 * Parse and render markdown
 */
export default function MarkdownRenderer<
  T extends ElementType = 'div',
  P = ComponentProps<T>,
>(
  props: {
    /** The container element of the rendered result */
    as?: T
    renderer?: MarkdownIt
    /** Whether to call `MarkdownIt().renderInline()` */
    inline?: boolean
    /** The Markdown source */
    children: string
  } & P,
) {
  const {
    as: Container = 'div',
    renderer = mdFull,
    inline,
    children,
    ...containerProps
  } = props
  const __html = useMemo(
    () =>
      inline ? renderer.renderInline(children) : renderer.render(children),
    [inline, renderer, children],
  )

  return <Container {...containerProps} dangerouslySetInnerHTML={{ __html }} />
}
